import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import HelloWorld from './components/HelloWorld.vue'
import topComponent from './components/topComponent.vue'
// import httpApi from './public/httpX'
import store from './store'
import * as echarts from 'echarts'
import ElementPlus from 'element-plus'
import lang from 'element-plus/lib/locale/lang/zh-cn'
// import locale from 'element-plus/lib/locale'
// 设置语言
// locale.use(lang)
// import ECharts from 'vue-echarts/components/ECharts.vue'

// import { Button, message } from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';

import 'element-plus/lib/theme-chalk/index.css'
import './public.css'
import {Vue} from "vue-class-component";
// @ts-ignore
import locale from 'element-plus/lib/locale/lang/zh-cn';


// import 'ant-design-vue/dist/antd.css'; // or 'ant-design-vue/dist/antd.less'
const app = createApp(App);
app.use(ElementPlus,{ locale });

// const vm = createApp(App)
app.use(store);
app.use(ElementPlus)
app.use(router)
app.use(store)



// app.config.globalProperties.$http = httpApi;

app.mount('#app');


// npm i element-plus
// import ElementPlus from 'element-plus'
// import 'element-plus/lib/theme-chalk/index.css'

// 这里可以注册全局的组件
app.component('my-component-name', HelloWorld);
app.component('topComponent', topComponent);

//使用钩子函数对路由进行权限跳转
router.beforeEach((to:any, from, next) => {
    console.log('beforeEachto',to)
    document.title = `${to.name} | 高校数据大屏`;
    next();
});
